import { render, staticRenderFns } from "./BeneficiaryView.vue?vue&type=template&id=738ef7e0"
import script from "./BeneficiaryView.vue?vue&type=script&lang=js"
export * from "./BeneficiaryView.vue?vue&type=script&lang=js"
import style0 from "./BeneficiaryView.vue?vue&type=style&index=0&id=738ef7e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports